import React, { FunctionComponent } from 'react'

export type ExampleComponentProps = {
  text: string
  color: string
}

const ExampleComponent: FunctionComponent<ExampleComponentProps> = ({ text, color }) => <h1 className={`font-sans text-lg text-${color}`}>{text}</h1>
export default ExampleComponent
